import { PrintCampusSummary } from '@/components/chefs/print/print-campus-summary'
import { PrintPreliminaryScope } from '@/components/chefs/print/print-preliminary-watermark'
import { campusBlockId } from '@/lib/chefs/print-plan'
import type { OrderedSheet } from '@/lib/chefs/print-words'
import type { Campus } from '@/lib/chefs/types'

interface PrintAllCampusesProps {
  iso: string
  /** The delivery day: every sheet names it in its repeating header. */
  date: Date
  /** The day's sheets in stop order (`orderedSheetsFor`), each with its stop line. */
  sheets: ReadonlyArray<OrderedSheet<Campus>>
  kitchenName: string
  /** Per school sheet (`campusBlockId`) while that school can still change its order (PROD-1452). */
  campusLocksAtLabel?: Record<string, string>
}

// One campus summary per page, in the order the van unloads: each school
// starts a fresh page. The sheet's own repeating header names the school, its
// stop, the packet, the kitchen and the day on every printed page. Each page
// is tagged for height measurement (see print-plan).
export function PrintAllCampuses({ iso, date, sheets, kitchenName, campusLocksAtLabel }: PrintAllCampusesProps) {
  return (
    <div className="font-sans text-black">
      {sheets.map(({ campus, stopLine }, i) => (
        <div
          key={campus.id}
          data-print-block={campusBlockId(iso, campus.id)}
          className={i < sheets.length - 1 ? 'print-page-break' : undefined}>
          <PrintPreliminaryScope locksAtLabel={campusLocksAtLabel?.[campusBlockId(iso, campus.id)]}>
            <PrintCampusSummary campus={campus} kitchenName={kitchenName} date={date} stopLine={stopLine} />
          </PrintPreliminaryScope>
        </div>
      ))}
    </div>
  )
}
